import * as React from 'react';
import { StyledBox } from './Box.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultElement = 'div';
function Box(props, ref) {
  const {
    flex,
    inline,
    center,
    column,
    minWidth,
    maxWidth,
    minHeight,
    maxHeight,
    fullWidth,
    ...htmlAttributes
  } = props;
  const styledProps = {
    $flex: flex,
    $inline: inline,
    $center: center,
    $column: column,
    $minWidth: minWidth,
    $maxWidth: maxWidth,
    $minHeight: minHeight,
    $maxHeight: maxHeight,
    $fullWidth: fullWidth
  };

  // TODO: FixME
  // @ts-ignore
  return /*#__PURE__*/_jsx(StyledBox, {
    ref: ref,
    ...styledProps,
    ...htmlAttributes
  });
}
export default /*#__PURE__*/React.forwardRef(Box);